import { applyMiddleware, createStore } from 'redux';
import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import * as rootReducer from './reducers';

const persistConfig = {
  key: 'primary',
  storage,
  blacklist: ['auth', 'incidentList', 'history', 'report']
};
let reducer = persistCombineReducers(persistConfig, rootReducer);

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default () => {
  let store = createStore(reducer, composeWithDevTools(applyMiddleware(thunk)));
  let persistor = persistStore(store);
  return { store, persistor };
};
